(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["impact-store-styles"] && !Shopify.designMode) return;
  try {
    function impactStoreEnhance() {
  const field = document.querySelector('[data-impact-product]');
  if (field && !field.value) {
    const product = new URLSearchParams(window.location.search).get('product');
    if (product) field.value = product.slice(0, 250);
  }
  document.querySelectorAll('.pro_main_c .qty a[role="button"]').forEach(control => {
    if (control.dataset.impactKeyboard) return;
    control.dataset.impactKeyboard = 'true';
    control.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault(); control.click();
      }
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', impactStoreEnhance);
else impactStoreEnhance();
document.addEventListener('shopify:section:load', impactStoreEnhance);
  } catch(e) { console.error(e); }
})();

})();
